import { VERTICALS } from '../data/verticals';
import VerticalPage from './VerticalPage';

const Hostels = () => <VerticalPage config={VERTICALS['hostels']} />;

export default Hostels;
